import { useEffect } from "react";

export interface IPageTitleProps {
  title: string;
}

export default function PageHeadTitle({ title }: IPageTitleProps) {
  useEffect(() => {
    const prevTitle = document.title;
    // MyHIS: the product name, not CARE's, in every tab title.
    if (title) {
      document.title = title + " | MyHIS";
    } else {
      document.title = "MyHIS";
    }
    return () => {
      document.title = prevTitle;
    };
  }, [title]);

  return <></>;
}
